import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_REPORTS,
  PROPOSAL_BY_SELLER,
  SEARCH_ASSOCIATES,
} from './actionType';

import { ReportsApiResponseSuccess, ReportsApiResponseError } from './action';

import {
  getReports as reportsGet,
  proposalBySeller as proposalSeller,
  searchAssociates as getSearchAssociates,
} from '../../helpers/backend_helper';

import { notifySuccess, notifyError } from '../../components/notify';

function* getReports() {
  try {
    const response = yield call(reportsGet);
    yield put(ReportsApiResponseSuccess(GET_REPORTS, response));
  } catch (error) {
    yield put(ReportsApiResponseError(GET_REPORTS, error));
  }
}

function* proposalBySeller(data) {
  try {
    const response = yield call(proposalSeller, data.payload.data);
    yield put(ReportsApiResponseSuccess(PROPOSAL_BY_SELLER, response));
    notifySuccess('Relatório gerado com sucesso!');
  } catch (error) {
    const response = yield put(
      ReportsApiResponseError(PROPOSAL_BY_SELLER, error)
    );
    notifyError(response.payload.error.response.data.messages.error);
  }
}

function* searchAssociates(data) {
  try {
    const response = yield call(getSearchAssociates, data.payload.data);
    yield put(ReportsApiResponseSuccess(SEARCH_ASSOCIATES, response));
  } catch (error) {
    ReportsApiResponseError(SEARCH_ASSOCIATES, error);
  }
}

export function* watchGetReports() {
  yield takeEvery(GET_REPORTS, getReports);
}

export function* watchProposalBySeller() {
  yield takeEvery(PROPOSAL_BY_SELLER, proposalBySeller);
}

export function* watchSearchAssociates() {
  yield takeEvery(SEARCH_ASSOCIATES, searchAssociates);
}

function* ReportsSaga() {
  yield all([fork(watchGetReports)]);
  yield all([fork(watchProposalBySeller)]);
  yield all([fork(watchSearchAssociates)]);
}

export default ReportsSaga;
